export default "__VITE_ASSET__B09mwa7j__"